<template>
    <div class="d-flex justify-content-center align-items-start mt-5 vh-100">
      <form
        id="fs-frm"
        name="simple-contact-form"
        accept-charset="utf-8"
        action="https://formspree.io/f/meoeelaq"
        method="post"
        class="d-flex formulaire flex-column w-25 p-4 border rounded shadow bg-light mt-5"
      >
        <fieldset class="border-0">
          <div class="mb-3 d-flex flex-column">
            <label for="full-name" class="form-label text-start">Nom *</label>
            <input
              type="text"
              name="name"
              id="full-name"
              class="form-control"
              required
            />
          </div>
  
          <div class="mb-3 d-flex flex-column">
            <label for="email-address" class="form-label text-start">Adresse mail *</label>
            <input
              type="email"
              name="_replyto"
              id="email-address"
              class="form-control"
              required
            />
          </div>
  
          <div class="mb-3 d-flex flex-column">
            <label for="message" class="form-label text-start">Message</label>
            <textarea
              rows="5"
              name="message"
              id="message"
              class="form-control"
              required
            ></textarea>
          </div>
        </fieldset>
  
        <button type="submit" class="btn btn-primary">Envoyer</button>
      </form>
    </div>
  </template>
  

<script>
    export default {
        name: 'FormulaireContact',
        mounted() {
    // Réinitialiser le scroll lorsque le composant est complètement monté
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  }
    }
</script>

<style scoped>
.formulaire{
  min-width: 300px;
}

button {
    background-color: #32825e;
    border: none;
    font-weight: 500;
}

button:hover {
    background-color: #389467;
}
</style>